import { render, staticRenderFns } from "./textbookIndex.vue?vue&type=template&id=daf0b4f4&scoped=true&"
import script from "./textbookIndex.vue?vue&type=script&lang=js&"
export * from "./textbookIndex.vue?vue&type=script&lang=js&"
import style0 from "./textbookIndex.vue?vue&type=style&index=0&id=daf0b4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0b4f4",
  null
  
)

export default component.exports